// src/pages/admin/Bookings/components/LoadingCenter.jsx
import React from "react";
import { Box, CircularProgress, Stack, Typography } from "@mui/material";

const LoadingCenter = ({ text = "Loading…" }) => (
  <Box
    aria-busy="true"
    sx={{
      display: "grid",
      placeItems: "center",
      minHeight: "60vh",
      textAlign: "center",
      px: 2,
    }}>
    <Stack spacing={1.5} alignItems="center">
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </Stack>
  </Box>
);

export default LoadingCenter;
